<template>
  <div class="contain">
    <div class="personCont" style="max-height: 100%; width: 100%; text-align: left; overflow: auto;">
      <div class="uploadControls flex ">
        <div class="ml20" v-hasPermi="['fireArchivesInfo:uploadFireOrganization']">
          <el-button type="success" size="mini" @click="downMoban('safety_responsible_person')">
            下载模板
          </el-button>
                      <!-- :fileType="['doc', 'docx']" -->
          <fileUpload
            v-model="uploadList.safety_responsible_person"
            class="mt20"
            :uploadData="uploadData.safety_responsible_person"
            :fileType="['doc', 'docx','pdf']"
            :fileUrl="'/fireArchives/Archives/uploadFireOrganization'"
            :fileSize="30"
            :limit="1"
            @handleRemove="remove(uploadList.safety_responsible_person)"
            :btnText="'上传安全责任人任命书'"
          />
        </div>
        <div class="ml20" v-hasPermi="['fireArchivesInfo:uploadFireOrganization']">
          <el-button type="success" size="mini" @click="downMoban('fire_safety_manager')">
            下载模板
          </el-button>

          <fileUpload
            v-model="uploadList.fire_safety_manager"
            class="mt20"
            :uploadData="uploadData.fire_safety_manager"
            :fileType="['doc', 'docx','pdf']"
            :fileUrl="'/fireArchives/Archives/uploadFireOrganization'"
            :fileSize="30"
            :limit="1"
            @handleRemove="remove(uploadList.fire_safety_manager)"
            :btnText="'上传消防安全管理人任命书'"
          />
        </div>
        <div class="ml20" v-hasPermi="['fireArchivesInfo:uploadFireOrganization']">
          <el-button type="success" size="mini" @click="downMoban('fire_safety_department')">
            下载模板
          </el-button>
          <fileUpload
            v-model="uploadList.fire_safety_department"
            class="mt20"
            :uploadData="uploadData.fire_safety_department"
            :fileType="['doc', 'docx','pdf']"
            :fileUrl="'/fireArchives/Archives/uploadFireOrganization'"
            :fileSize="30"
            @handleRemove="remove(uploadList.fire_safety_department)"
            :limit="1"
            :btnText="'上传消防安全归口管理部门文件'"
          />
        </div>
        <!-- 新添加的 -->
        <div class="ml20" v-hasPermi="['fireArchivesInfo:uploadFireOrganization']">
          <el-button type="info" disabled size="mini" @click="downMoban('fire_publicity_education')">
            下载模板
          </el-button>
          <fileUpload
            v-model="uploadList.fire_publicity_education"
            class="mt20"
            :uploadData="uploadData.fire_publicity_education"
            :fileType="['doc', 'docx','pdf']"
            :fileUrl="'/fireArchives/Archives/uploadFireOrganization'"
            :fileSize="30"
            @handleRemove="remove(uploadList.fire_publicity_education)"
            :limit="1"
            :btnText="'上传消防宣传教育等工作的消防管理人员的正式文件'"
          />
        </div>
        <div class="ml20" v-hasPermi="['fireArchivesInfo:uploadFireOrganization']">
          <el-button type="info" disabled size="mini" @click="downMoban('fire_protection_system_duty')">
            下载模板
          </el-button>
          <fileUpload
            v-model="uploadList.fire_protection_system_duty"
            class="mt20"
            :uploadData="uploadData.fire_protection_system_duty"
            :fileType="['doc', 'docx','pdf']"
            :fileUrl="'/fireArchives/Archives/uploadFireOrganization'"
            :fileSize="30"
            @handleRemove="remove(uploadList.fire_protection_system_duty)"
            :limit="1"
            :btnText="'上传自动消防系统值班操作管理人员正式文件'"
          />
        </div>
        <div class="ml20" v-hasPermi="['fireArchivesInfo:uploadFireOrganization']">
          <el-button type="info" disabled size="mini" @click="downMoban('fire_inspection_maintenance')">
            下载模板
          </el-button>
          <fileUpload
            v-model="uploadList.fire_inspection_maintenance"
            class="mt20"
            :uploadData="uploadData.fire_inspection_maintenance"
            :fileType="['doc', 'docx','pdf']"
            :fileUrl="'/fireArchives/Archives/uploadFireOrganization'"
            :fileSize="30"
            @handleRemove="remove(uploadList.fire_inspection_maintenance)"
            :limit="1"
            :btnText="'上传消防设施（器材）检验与维修管理人员正式文件'"
          />
        </div>
        <div class="ml20" v-hasPermi="['fireArchivesInfo:uploadFireOrganization']">
          <el-button type="info" disabled size="mini" @click="downMoban('fire_patrol_management')">
            下载模板
          </el-button>
          <fileUpload
            v-model="uploadList.fire_patrol_management"
            class="mt20"
            :uploadData="uploadData.fire_patrol_management"
            :fileType="['doc', 'docx','pdf']"
            :fileUrl="'/fireArchives/Archives/uploadFireOrganization'"
            :fileSize="30"
            @handleRemove="remove(uploadList.fire_patrol_management)"
            :limit="1"
            :btnText="'上传变更防火检查（巡查）管理人员正式文件'"
          />
        </div>
      </div>
      <div class="topTwo" style="width: 100%;overflow:hidden">
        <div v-for="(item, index) in selectList" style="width: 22%; margin-top:20px">
          <el-row>
            <el-col :span="15">
              <el-select :disabled="index == 0" v-model="item.position" @change="changeSelect">
                <el-option label="无" v-if="index == 1" value="0"></el-option>
                <el-option v-for="(it, ind) in peopleList" :label="it.dictLabel" v-if="index == ind" :value="it.dictValue">{{ it.dictLabel }}</el-option>
              </el-select>
            </el-col>
            <el-col :span="9">
              <el-input :disabled="item.position == 0 || true" v-model="item.name" @blur="changeSelect"></el-input>
            </el-col>
          </el-row>
          <el-row class="mt10 center">
            <el-col v-show="index == 1" :span="12">
              <el-button size="mini" class="ml10" @click="addTree('child')" v-hasPermi="['fireArchives:fireArchivesStation:saveOrUpdate']"
                >增加 <i class="el-icon-caret-right" style="font-size:13px;"></i>
              </el-button>
            </el-col>
          </el-row>
        </div>
      </div>

      <div class="topTwo flex" style="width: 100%;">
        <div class="" style="width: 20%; margin-right: 10px" v-if="selectList[1].child" v-for="(ite, inde) in selectList[1].child">
          <div v-for="(item, index) in ite" style="width: 100%; margin-top:20px">
            <el-row>
              <el-col :span="20" v-if="!(item.position == 12)">
                <el-select style="width:100%" v-model="item.position" @change="changeSelect">
                  <el-option v-for="(it, ind) in peopleList" :label="it.dictLabel" :value="it.dictValue" v-if="!(it.dictValue == 1 || it.dictValue == 2)">{{
                    it.dictLabel
                  }}</el-option>
                </el-select>
              </el-col>
              <el-col :span="24" v-else>
                <el-col :span="20">
                  <el-input v-model="item.remark" @blur="changeRemark(item)"></el-input>
                </el-col>
                <el-col :span="4">
                  <el-button @click="backTo(item)" style="margin-top:5px" size="mini">选择</el-button>
                </el-col>
              </el-col>
              <el-col :span="20">
                <el-input v-model="item.name" @blur="changeSelect"></el-input>
              </el-col>
              <el-col :span="4" style="padding-top: 5px">
                <el-button
                  size="mini"
                  v-if="index == 0"
                  type="danger"
                  class="mt10"
                  @click="delTree(1, inde)"
                  v-hasPermi="['fireArchives:fireArchivesStation:saveOrUpdate']"
                  >删除</el-button
                >
                <el-button size="mini" v-else type="danger" @click="delTree(0, inde, index)" v-hasPermi="['fireArchives:fireArchivesStation:saveOrUpdate']"
                  >删除</el-button
                >
              </el-col>
            </el-row>
            <el-row v-show="index == 0" class="mt10 center">
              <el-col :span="12">
                <el-button size="mini" class="ml10" @click="addTree(inde)" v-hasPermi="['fireArchives:fireArchivesStation:saveOrUpdate']"
                  >增加
                  <p class="el-icon-caret-bottom"></p
                ></el-button>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
      <div class="center treecont" style="min-height: 500px">
        <vue2-org-tree :data="data" v-if="showtree" />
      </div>
    </div>
    <div class="center mt20">
      <el-button type="primary" @click="submit" autofocus v-hasPermi="['fireArchives:fireArchivesStation:saveOrUpdate']">保存</el-button>
      <!-- <el-button type="primary" @click="setTree">生成树</el-button> -->
    </div>
  </div>
</template>

<script>
export default {
  props: ["dictValue", "dictType", "dict"],

  data() {
    return {
      peopleList: [], // 责任人，电工数组
      uploadList: {
        safety_responsible_person: "",
        fire_safety_manager: "",
        fire_safety_department: "",
        fire_publicity_education:"",
        fire_protection_system_duty:"",
        fire_inspection_maintenance:"",
        fire_patrol_management:"",
      },
      uploadData: {
        safety_responsible_person: null,
        fire_safety_manager: null,
        fire_safety_department: null,
        fire_publicity_education:null,
        fire_protection_system_duty:null,
        fire_inspection_maintenance:null,
        fire_patrol_management:null,
      },
      selectList: [
        {
          position: "1",
          name: "",
          value: "",
          companyNum: this.$route.query.id,
        },
        {
          position: "2",
          name: "",
          value: "",
          companyNum: this.$route.query.id,
          child: [],
        },
      ], // 新增时的数组
      treeList: [], // 生成的树
      data: {},
      showtree: false,
    };
  },
  created() {

    for (var i in this.uploadData) {
      var uploadData = { fireArchivesInfo: new Blob([JSON.stringify({ companyNum: this.$route.query.id || "", remark: i })], { type: "application/JSON" }) };
      this.uploadData[i] = uploadData;
      console.log(this.uploadData,'this.uploadData');
    }

    this.getList();
    this.$get("/system/dict/data/notPageList", { dictType: "fire_organization" }).then((res) => {
      this.peopleList = res.data;
      var map = {};
      this.peopleList.map((it) => {
        map[it.dictValue] = it.dictLabel;
      });
      this.peopleMap = map;
      this.peopleMap[""] = "";
      this.peopleMap["0"] = "暂无人员";

      console.log(this.peopleMap);
    });
  },
  watch: {
    showtree(val) {
      if (val) {
        setTimeout(() => {
          var d = document.getElementsByClassName("org-tree-node-label-inner");
          for (var i = 0; i < d.length; i++) {
            var str = d[i].innerHTML;
            d[i].innerHTML = str.split(":")[1] ? str.split(":")[0] + ":" + "<br/>" + str.split(":")[1] : str.split(":")[0];
          }
        }, 10);
      }
    },
  },
  methods: {
    remove(url) {
      console.log(this.uploadList,url,'this.uploadList');
      const params = { fireArchives: url, companyNum: this.$route.query.id };
      console.log(params,url,'params,url')
      this.$put(`/fireArchives/Archives/removeFireOrganization`, params).then((res) => {
        this.$message({message: res.msg,type: "success", duration: 700,});
      });
    },
    downMoban(remark) {
      console.log(remark,'remark');
      this.$get("/fireArchives/Archives/downloadFireOrganizationUrl", {
        remark,
      }).then((res) => {
        console.log(res,'res');
        window.location = res.msg;
      });
    },
    changeRemark(item) {
      if (!item.remark) {
        (item.position = ""), (item.remark = "");
      }
      setTimeout(() => {
        this.setTree();
      }, 10);
    },
    backTo(item) {
      item.position = "";
      item.remark = "";
      setTimeout(() => {
        this.setTree();
      }, 10);
    },
    getList() {
      this.$get("/fireArchives/Archives/getFireOrganizationUrl", {
        companyNum: this.$route.query.id,
      }).then((res) => {
        log(res,'res')
        res.data.map((item) => {
          this.uploadList[item.remark] = item.fireArchives;
        });
      });
      this.$get("/fireArchives/station/list", {
        companyNum: this.$route.query.id,
        majorItem: this.dictValue,
      }).then((res) => {
        console.log(res);
        var list = [];

        const check = (arr) => {
          arr.map((item, index) => {
            if (item.level == 1) {
              list[0] = {
                position: String(item.position),
                name: item.label.split(":")[1] || "",
                value: "",
                remark: item.position == 12 ? item.label.split(":")[0] : item.remark || "",
                companyNum: this.$route.query.id,
              };
            } else if (item.level == 2) {
              list[1] = {
                position: String(item.position),
                name: item.label.split(":")[1] || "",
                value: "",
                remark: item.position == 12 ? item.label.split(":")[0] : item.remark || "",

                companyNum: this.$route.query.id,
                child: [],
              };
            } else if (item.level == 3) {
              console.log(item);
              console.log(list[1].child);
              list[1].child.push([
                {
                  position: String(item.position),
                  name: item.label.split(":")[1] || "",
                  value: "",
                  remark: item.position == 12 ? item.label.split(":")[0] : item.remark || "",

                  companyNum: this.$route.query.id,
                  child: [],
                },
              ]);
              if (item.children && item.children.length) {
                console.log(item);
                console.log(list[1].child);
                item.children.map((it, ind) => {
                  list[1].child[index].push({
                    position: it.position,
                    name: it.label.split(":")[1] || "",
                    remark: it.position == 12 ? it.label.split(":")[0] : it.remark || "",

                    value: "",
                    companyNum: this.$route.query.id,
                    child: [],
                  });
                });
              }
            }
            if (item.children) {
              check(item.children);
            }
          });
        };

        check([res.data[0]]);

        this.data = res.data.length ? res.data[0] : {};
        this.showtree = true;
        console.log(list);
        this.selectList = list;
      });
    },
    addTree(e) {
      if (e == "child") {
        if (this.selectList[1].child.length >= 5) {
          this.$message.warning("最多增加5人");
          return;
        }
        this.selectList[1].child.push([
          {
            position: "",
            name: "",
            value: "",
            remark: "",
            companyNum: this.$route.query.id,
          },
        ]);
      } else {
        if (this.selectList[1].child[e].length >= 4) {
          this.$message.warning("最多增加3人");
          return;
        }
        this.selectList[1].child[e].push({
          position: "",
          name: "",
          value: "",
          remark: "",

          companyNum: this.$route.query.id,
        });
      }
      setTimeout(() => {
        this.setTree();
      }, 10);
    },
    changeSelect() {
      // alert(1)
      setTimeout(() => {
        this.setTree();
      }, 10);
    },
    delTree(e, inde, index) {
      if (e) {
        if (this.selectList[1].child.length <= 1) {
          this.$message.warning("请保留至少一组人员");
          return;
        }
        this.selectList[1].child.splice(inde, 1);
      } else {
        if (this.selectList[1].child[inde].length <= 1) {
          this.$message.warning("请保留至少一个人员");
          return;
        }
        this.selectList[1].child[inde].splice(index, 1);
      }
      setTimeout(() => {
        this.setTree();
      }, 10);
    },

    setTree() {
      this.showtree = false;
      var tree = this.data;
      tree.label = this.selectList[0].position == 0 ? "暂无人员" : this.peopleMap[this.selectList[0].position] + ":" + this.selectList[0].name || "";
      tree.children = [];
      tree.position = this.selectList[0].position;
      tree.companyNum = this.selectList[0].companyNum;
      tree.majorItem = this.dictValue;
      tree.level = 1;
      // 二级 副站长
      var obj = {};
      obj.label = this.selectList[1].position == 0 ? "暂无人员" : this.peopleMap[this.selectList[1].position] + ":" + this.selectList[1].name || "";
      obj.children = [];
      obj.position = this.selectList[1].position;
      obj.companyNum = this.selectList[0].companyNum;
      obj.majorItem = this.dictValue;
      obj.level = 2;

      tree.children.push(obj);

      //遍历已选择
      this.selectList[1].child.map((item, index) => {
        var obj2 = {
          label: item[0].position == 0 ? "暂无人员" : (item[0].position == 12 ? item[0].remark : this.peopleMap[item[0].position]) + ":" + item[0].name || "",
          children: [],
          position: item[0].position,
          companyNum: item[0].companyNum,
          majorItem: this.dictValue,
          level: 3,
        };
        obj.children.push(obj2);
        item.map((it, index) => {
          if (index > 0) {
            obj2.children.push({
              label: it.position == 0 ? "暂无人员" : (it.position == 12 ? it.remark : this.peopleMap[it.position]) + ":" + it.name || "",
              position: it.position,
              companyNum: it.companyNum,
              majorItem: this.dictValue,
              level: 4,
            });
          }
        });
      });
      console.log(this.data);
      this.$set(this, "data", tree);
      setTimeout(() => {
        this.showtree = true;
      }, 100);
    },
    async submit() {
      if (this.data.label) {
        console.log(this.data);
        await this.$post("/fireArchives/station", this.data).then((res) => {
          this.$message({message: res.msg,type: "success", duration: 700,});
        });

        this.getList();
      } else {
        this.$message.error("请输入内容！");
      }
    },
  },
};
</script>

<style scoped>
.itemContent {
  width: 100%;
  overflow: hidden;
  /* background: pink; */
  /* background: pink; */
}
.topTree {
  overflow-x: auto;
  height: 100%;
  /* background-color: red; */
  width: 100%;
  display: flex;
  /* flex-direction: column; */
}
.contain {
  display: flex;
  align-items: center;
  flex: 1;
  padding: 10px;
  height: 100%;
  flex-direction: column;
}
.uploadControls{
  flex-wrap: wrap;
}
</style>
